import { render, staticRenderFns } from "./CancelReceiptBlock.vue?vue&type=template&id=5b7af641&scoped=true&"
import script from "./CancelReceiptBlock.vue?vue&type=script&lang=js&"
export * from "./CancelReceiptBlock.vue?vue&type=script&lang=js&"
import style0 from "./CancelReceiptBlock.vue?vue&type=style&index=0&id=5b7af641&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7af641",
  null
  
)

export default component.exports